var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"phone_iphone_24px"},React.createElement("path",{"id":"icon/hardware/phone_iphone_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M33.3332 2.08333H16.6666C13.7916 2.08333 11.4583 4.41666 11.4583 7.29166V42.7083C11.4583 45.5833 13.7916 47.9167 16.6666 47.9167H33.3332C36.2082 47.9167 38.5416 45.5833 38.5416 42.7083V7.29166C38.5416 4.41666 36.2082 2.08333 33.3332 2.08333ZM24.9999 45.8333C23.2708 45.8333 21.8749 44.4375 21.8749 42.7083C21.8749 40.9792 23.2708 39.5833 24.9999 39.5833C26.7291 39.5833 28.1249 40.9792 28.1249 42.7083C28.1249 44.4375 26.7291 45.8333 24.9999 45.8333ZM15.6249 37.5H34.3749V8.33333H15.6249V37.5Z","fill":"white"})));
}

PhoneInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
